import { expected } from '@aloft/toolkit-shared';
import { Button, Flex, Tooltip, Typography } from '@aloft/toolkit-sui';

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { useTkv2OrderContext } from '../../../controller/hooks/useTkv2ControllerOrder.ts';
import { useTkv2PairedCostSummaryDataV2 } from '../../../controller/routes/useTkv2PairedCostSummaryDataV2.tsx';
import { handleSaveZipV2 } from '../../../hooks/handleSaveZipV2.tsx';
import { useToaster } from '../../../hooks/useToaster/useToaster.tsx';
import { ModuleContainer } from '../../../layout/ModuleContainer.tsx';
import { selectUser } from '../../../redux/features/selectors/accountSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { useTkv2SiteValueChartsParams } from '../../referenceView/utils/useTkv2SiteValueChartsParams.ts';

export const LegacyExportModule = () => {
  const toast = useToaster();
  const [saveOnNextRender, setSaveOnNextRender] = useState(false);
  const siteValueChartParams = useTkv2SiteValueChartsParams();
  const navigate = useNavigate();

  const { id: accountID } = useAppSelector(selectUser);
  const context = useTkv2OrderContext();
  const props = expected(useTkv2PairedCostSummaryDataV2(context, expected(accountID)));
  const addressLine = props?.subjectMetadata.address ?? '';

  useEffect(() => {
    if (saveOnNextRender) {
      try {
        setSaveOnNextRender(false);
        handleSaveZipV2(props, siteValueChartParams, addressLine);
        toast({
          type: 'success',
          id: 'toolkit-export-success',
          title: 'Your export has been downloaded.',
        });
      } catch (e) {
        console.error('Toolkit export failed', e);
        toast({
          type: 'error',
          id: 'toolkit-export-error',
          title: 'Toolkit export failed.',
          body: `Failed to generate Toolkit export. Please try again or contact support.`,
        });
      }
    }
  }, [addressLine, props, saveOnNextRender, siteValueChartParams, toast]);

  return (
    <ModuleContainer moduleID="legacy-export">
      <Flex flexDirection="column" gap="1rem" paddingX="3rem">
        <Typography variant="h1">Export Legacy Order</Typography>
        <Typography variant="body1">
          Export PDFs to review the adjustment analysis and cost approach for this order. Editing
          legacy orders is no longer supported in Toolkit as of September 2024.
        </Typography>
        <Flex gap="1rem">
          <Button
            onClick={() => navigate('/orders')}
            variant="secondary"
            text="Back to all orders"
          />
          <Tooltip isDisabled={!props.publicRecords.isLoading} label="Loading">
            <Button
              onClick={() => setSaveOnNextRender(true)}
              disabled={props?.publicRecords.isLoading}
              text="Export PDFs"
            />
          </Tooltip>
        </Flex>
      </Flex>
    </ModuleContainer>
  );
};
